import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './common.module.css';
import linePattern from './assets/linePatternFlat.svg';

const Config = ({ onVersionSelect }) => {
  const [selectedVersion, setSelectedVersion] = useState('');
  const navigate = useNavigate();

  const handleVersionChange = (event) => {
    setSelectedVersion(event.target.value);
  };

  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);


  const showPopupModal = (message) => {
    setPopupMessage(message);
    setShowPopup(true);
  }

  const handleStart = () => {
    if (!selectedVersion) {
      showPopupModal('Please select an OpenAPI Specification version.');
      return;
    }
    onVersionSelect(selectedVersion);
    navigate('/wizard');
  };

  return (
    <div className={styles.dashboardWrap}>
      <div className={styles.dashboardBody}>
        <div className={styles.card}>
          <h1 className={styles.title}>Welcome to SpecWizard</h1>
          <p className={styles.subtitle}>Select the <span className={styles.violet}>OpenAPI</span> Specification (OAS) version to begin:</p>
          <select
            value={selectedVersion}
            onChange={handleVersionChange}
            className={styles.selectDropdown}
          >
            <option value="" disabled>
              Select Version
            </option>
            <option value="3.0.3">3.0.3</option>
            <option value="3.1.0">3.1.0</option>
          </select>
          <button className={styles.button} onClick={handleStart}>
            Start Configuring
          </button>
        </div>
      </div>
      <div className={styles.bottomPattern}>
        <img src={linePattern} alt="illustration" />
      </div>
      <div className="navbar">
        <a href="/dashboard">Home</a>
        <div className="account-container">
          <a href="#" className="account-link">My Account</a>
          <div className="account-dropdown">
            <a href="/user/profile">Profile</a>
            <a href="/user/sessions">Sessions</a>
          </div>
        </div>
        <a href="/user/logout">Logout</a>
      </div>
      {showPopup && (
        <div className={styles.popupOverlay}>
          <div className={styles.popup}>
            <h3>Alert !!</h3>
            <p>{popupMessage}</p>
            <button onClick={() => setShowPopup(false)} className="popup-close-button">
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Config;
